module.exports = __webpack_public_path__ + "img/logo-las-lagunas.760262c1.png";